import builder from '../builder';
import MoneyWallet from '../../streamline-icons/light/money-wallet.svg';

export default builder('IconMoneyWalletLight', MoneyWallet);
